import { CURRENCY_CODES } from '../../Base/Components/Inputs/FormattedPriceInput/PriceCurrency';
import { useAppContext } from '../../../Services/AppContext';
import { useMemo } from 'react';

export default function useCurrency() {
	const { currency } = useAppContext();

	const currencyCode = useMemo(() => {
		switch (currency) {
			case 'USD':
			case 'COP':
			case 'MXN':
			case 'PEN':
				return CURRENCY_CODES[currency];
			default:
				return currency;
		}
	}, []);

	const withCurrencyCode = (value: string) => {
		switch (currency) {
			case 'USD':
			case 'COP':
			case 'MXN':
			case 'PEN':
				return `${currencyCode} ${value}`;
			default:
				return `${value} ${currencyCode}`;
		}
	};

	return { currencyCode, withCurrencyCode };
}
